import * as React from "react";
import { useEffect, useReducer } from "react";
import { Field } from "../modelDialogs/BaseDialog";
import { itx } from "../translationItx/itx";
import type KnxProductData from "../KnxProductdata";

export default function UI_KnxProductVoltusData(props: { articleNo: string; productData?: KnxProductData }) {
  const { articleNo, productData } = props;
  const [, redraw] = useReducer(value => value + 1, 0);
  const data = productData?.productInfo.RetailerData?.[articleNo];

  useEffect(() => {
    let active = true;
    productData?.loadPriceAndAvailability(articleNo).then(() => { if (active) redraw(); });
    return () => { active = false; };
  }, [articleNo, productData]);

  return (
    <>
      {data?.ean && (
        <Field label={itx("ui_KnxProductData.eanNumber", "EAN Number")}>{data.ean}</Field>
      )}

      {data?.page && (
        <Field label={itx("ui_KnxProductData.pageLink", "Go to Retailer")}>
          <button className="button" onClick={() => window.open(data.page, "_blank")}>
            <img src="/images/VoltusLogo.png" style={{ height: "24px" }} />
          </button>
        </Field>
      )}
      {data?.price && (
        <Field label={itx("ui_KnxProductData.price", "Price")}>
          <span>{data.price}</span>
        </Field>
      )}
      {data?.availability && (
        <Field label={itx("ui_KnxProductData.availabilty", "Availability")}>{data.availability}</Field>
      )}
    </>
  );
}
